export const formatterData = {
    transformData: (listData) => {
        return listData.map((item) => {
            const listKt = [];

            for (let i = 1; i <= 20; i++) {
                const nameKey = `nameKt${i}`;
                const moneyKey = `moneyKt${i}`;
                const quantityKey = `quantityKt${i}`;
                const priceKey = `priceKt${i}`;
                const discountKey = `discountKt${i}`;

                if (item[nameKey]) {
                    listKt.push({
                        name: item[nameKey],
                        money: item[moneyKey],
                        quantity: item[quantityKey],
                        price: item[priceKey],
                        discount: item[discountKey],
                        index: i - 1,
                    });
                }

                delete item[nameKey];
                delete item[moneyKey];
                delete item[quantityKey];
                delete item[priceKey];
                delete item[discountKey];
            }

            return {
                ...item,
                listKt,
            };
        })
    },

    /**
     * Chuyển đổi chuỗi ngày tháng thành chi tiết
     *
     * @param {string} dateString - ví dụ "2024-12-31"
     * */
    parseDateTimeToList: (dateString) => {
        const [year, month, day] = dateString.split("-");

        return [year, month, day];
    },

    parseToDateTime: (day, month, year) => {
        if (day && month && year) {
            return `${year}-${month}-${day}`;
        }
        return "";
    },

    removeDiacritics: (str) => {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
}